import { Input } from '../../ui/input/input';
import { Button } from '../../ui/button/button';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { dialogActions } from '../slice/dialog-slice';
import { apiActions } from '../../../slices/api-slice';
import { ApiStoreGet, ApiStorePost } from '../../../api/front/store/api-store';
import { ResponseBase } from '../../../api/response-base';
import { SendStoreConfig } from './send-store-config';
import { StoreGetResponse, StorePostResponse } from '../../../models/api/front/store';
import { useAppSelector } from '../../../app/hooks';
import lodash from 'lodash';
import { deliveryActions } from '../../../slices/orders/delivery-slice';
import { useParams } from 'react-router-dom';
import { PathParams } from '../../../routes/routing-path';

interface RegisterDeliveryStoreProps {
  kijshopCd: string,
}

export const RegisterDeliveryStore = (props: RegisterDeliveryStoreProps) => {
  // - Hooks -
  const dispatch = useDispatch();
  const { kijshopCd } = props;
  // - State -
  const shopData = useAppSelector((state) => {
    return state.delivery.sendStore;
  }, lodash.isEqual);
  // -- 発送店舗名 --
  const [storeName, setStoreName] = useState('');
  // - Callback -
  // -- 発送店舗名更新 --
  const handlerChangeStoreName = useCallback((v) => {
    setStoreName(v);
  }, []);
  // -- 登録ボタン押下 --
  const handlerClickRegister = useCallback(() => {
    if (!storeName) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          '発送店舗名が入力されていません。',
        ],
        buttons: [
          {
            label: 'OK',
            callback: () => {
              dispatch(dialogActions.pop());
            },
          },
        ],
      }));
    } else {
      dispatch(apiActions.run(
        new ApiStorePost(
          kijshopCd,
          {
            shopName: storeName,
          },
        ),
        {
          onSuccess: () => {
            dispatch(apiActions.run(
              new ApiStoreGet({ kijshopCd }),
              {
                onSuccess: (res: ResponseBase<StoreGetResponse[]>) => {
                  if (res.body.data) {
                    dispatch(deliveryActions.setSendStoreState(res.body.data));
                    dispatch(dialogActions.pop());
                  }
                },
              },
            ));
          },
        },
      ));
    }
  }, [storeName]);
  // -- キャンセルボタン押下 --
  const handlerClickCancel = useCallback(() => {
    dispatch(dialogActions.pop());
  }, []);
  return (
    <div className="dialog_contents">
      <div className="dialog_contents__body">
        <div className="lh_2">発送店舗名</div>
        <Input
          value={storeName}
          onChange={(e) => handlerChangeStoreName(e.target.value)}
          maxLength={50}
          style={{ width: '100%' }}
        />
      </div>
      <div className="dialog_contents__footer">
        <Button
          label="キャンセル"
          onClick={handlerClickCancel}
        />
        <Button
          label="登録"
          onClick={handlerClickRegister}
        />
      </div>
    </div>
  );
};
